export default "__VITE_ASSET__5ebcdc40__"